import { ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

type CloseConfirmationPopupProps = {
  isShown: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  body: ReactElement | string;
  buttonText?: string;
};

export const CloseConfirmationPopup = ({
  isShown,
  onClose,
  onConfirm,
  title,
  body,
  buttonText,
}: CloseConfirmationPopupProps) => {
  const handleClose = () => {
    onClose();
    setTimeout(onConfirm, 150);
  };
  return (
    <Modal centered scrollable backdrop="static" keyboard={false} show={isShown} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onClose}>
          Go Back
        </Button>
        <Button variant="danger" onClick={handleClose}>
          {buttonText ? buttonText : 'Discard Changes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
